import { Controller } from "@hotwired/stimulus"
import { saveShiftLogEntry, saveChecklistLogEntry, generateUUID } from "../offline/db"

// Intercepts form submissions when offline, stores in IndexedDB, shows "saved offline" toast.
export default class extends Controller {
  static values = {
    shiftId: String,
    snapshotItemId: String,
    checklistEntryId: String,
    plantId: String
  }

  connect() {
    this.element.addEventListener("submit", this.handleSubmit.bind(this))
  }

  handleSubmit(event) {
    // Only intercept when offline
    if (navigator.onLine) return

    event.preventDefault()
    event.stopPropagation()

    this.saveOffline(event.target)
  }

  async saveOffline(form) {
    try {
      const formData = new FormData(form)
      const data = Object.fromEntries(formData.entries())

      let clientUuid

      if (this.hasShiftIdValue && this.shiftIdValue) {
        clientUuid = await saveShiftLogEntry({
          client_uuid: generateUUID(),
          shift_id: this.shiftIdValue,
          snapshot_item_id: this.snapshotItemIdValue,
          ...data
        })
      } else if (this.hasChecklistEntryIdValue && this.checklistEntryIdValue) {
        clientUuid = await saveChecklistLogEntry({
          client_uuid: generateUUID(),
          checklist_entry_id: this.checklistEntryIdValue,
          plant_id: this.plantIdValue,
          ...data
        })
      }

      document.dispatchEvent(new CustomEvent("toast:show", {
        detail: { message: "Saved offline — will sync when connected", type: "info" }
      }))

      // Visual feedback: mark form as submitted
      form.reset()
      const submitBtn = form.querySelector('[type="submit"]')
      if (submitBtn) {
        submitBtn.textContent = "Saved offline"
        submitBtn.disabled = true
        setTimeout(() => {
          submitBtn.textContent = "Submit"
          submitBtn.disabled = false
        }, 2000)
      }
    } catch (error) {
      console.error("[Offline] Save failed:", error)
      document.dispatchEvent(new CustomEvent("toast:show", {
        detail: { message: "Failed to save offline — please try again", type: "error" }
      }))
    }
  }
}
